// extracted by mini-css-extract-plugin
export default {"editor":"x28LTMP3XUYO3aDcV_kQ"};